import ChevronUpIcon from '@heroicons/react/24/outline/ChevronUpIcon';
import { Button } from 'components/ui/button';

export interface QuantityInputProps {
  maxQuantity: number;
  quantity: number;
  onChange: (quantity: number) => void;
  onIncreaseQuantity: () => void;
  onDecreaseQuantity: () => void;
  onBlur?: () => void;
  disabled?: boolean;
}
const QuantityInput = ({
  maxQuantity,
  onChange,
  onDecreaseQuantity,
  onIncreaseQuantity,
  quantity,
  disabled,
  onBlur,
}: QuantityInputProps) => {
  return (
    <section className="relative flex h-11 w-[6.25rem] items-center justify-between rounded-lg border lg:w-[80px]">
      <section>
        <input
          id="itemQuantity"
          type="number"
          aria-label="Quantity"
          data-testid="quantity-input"
          value={quantity}
          onBlur={onBlur}
          onChange={(e) => {
            if (parseInt(e.target.value) > 0 && parseInt(e.target.value) <= maxQuantity) {
              onChange(parseInt(e.target.value));
            }
          }}
          className="w-[53px] rounded-l-lg border-none text-center focus:border-none focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50"
          min="1"
          max={maxQuantity}
          disabled={disabled}
        />
      </section>
      <section className="absolute right-2 flex h-[42px] flex-col items-center justify-center">
        <>
          <Button
            disabled={quantity === maxQuantity || disabled}
            type="button"
            aria-label="increment"
            id="incrementBtn"
            onClick={onIncreaseQuantity}
            className="h-5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <ChevronUpIcon className="size-3" />
          </Button>
          <Button
            disabled={quantity === 1 || disabled}
            type="button"
            aria-label="decrement"
            id="decrementBtn"
            onClick={onDecreaseQuantity}
            className="h-5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <ChevronUpIcon className="size-3 rotate-180" />
          </Button>
        </>
      </section>
    </section>
  );
};

export default QuantityInput;
